export default "__VITE_ASSET___EyIIk69__"